import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import * as appConfigActions from "../../../reducers/appconfig.actions";
import {
    CommonService,
    SampleService
} from "../../../services/index";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./fairStock.html",
})
export class fairStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  mode = "Add";
  saveEvent: any;
  ironingList: any;
  barcode: any;
  presentationList: any;
  beltNoList: any;
  designList: any;
  matchColorList: any;
  samp_id: any;
  sampleType = ["INWARD", "OUTWARD"];
  styleNoList: any;
  typeList: any;

  @Input() set params(val: any[]) {}

  get params(): any[] {
    return this._params;
  }

  sample_no: any;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  groupdata: any = { sample_no: "", tot_pcs: 0, tot_amt: 0 };
  isLoading: boolean = false;
  companyList$ = [];
  sampleno: any;
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  designnoList = [];

  companyList: Observable<any[]>;
  partycodeList = [];
  usagepartslist = [];
  shadeList = [];
  colorList: any = [];
  shirtList: any = [];
  itemgroupList = [];
  sampleList = [];
  itemList = [];
  matchingList: any;
  accessoriesList = [
    "BUTTON",
    "THREAD",
    "COLLAR CANVAS",
    "KAJA THREAD",
    "BUTTON THREAD",
    "PLK",
    "CLR-UP",
    "CLR-DN",
    "BND DOWN",
    "BAND UP",
    "CUFF CANVAS",
    "MAIN LABEL",
    "EXTRA LABEL",
    "WASH CARE",
    "BONE",
    "BUT PATTI",
  ];
  sample: any = {};
  // itemList1: Observable<any[]>;

  @ViewChild("partycodeAuto") partycodeAuto;
  @ViewChild("partyAuto") partyAuto;
  @ViewChild("finAuto") gstAuto;

  invnoControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  itemCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partycomboControl: FormControl = new FormControl();
  brandControl: FormControl = new FormControl();

  groupData: any = [];
  data: any = {};
  sampledata: any = {
    sample_type: "",
  };
  groupList: any = [];
  categoryList: any;
  type: any;
  // {
  //     barcode :'',
  //     shirt_design_no: '',
  //     color: '',
  //     shade: '',
  //     size: '',
  //     slv: '',
  //     pcs: '',
  //     rate: '',
  //     mrp: '',
  //     amount: ''
  // }

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private sampService: SampleService,
    public datePipe: DatePipe
  ) {
    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
    this.data = this.commonService.itemMaster();
    console.log(this.data);
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {}

  /*  tableScroll(){
       
        $('.samplemain').width(window.innerWidth -525);
        $('.samplebody').width(window.innerWidth -485);f
        if(window.innerWidth>1500){
            $('.techstyleinput').width(window.innerWidth-1045);
        }else{
            $('.techstyleinput').width(window.innerWidth-865);
        }

    } */

  getdata(barcode) {
    let params = {
      barcode: barcode,
    };
    if (this.sampledata.sample_type == "OUTWARD") {
      // let   new_code = barcode;
      // for(var b=0;b<this.groupList.length;b++){
      //     let old_code = this.groupList[b].barcode;
      //     if(new_code==old_code){
      //         let no =b+1
      //         swal("Barcode number "+new_code+" Already Exists on s.no"+no);
      //         return true;
      //     }
      // }
      this.sampService.barcodeOutwardData(params).then((res: any) => {
        this.sampleList = res.data;

        let obj: any = {};
        obj.barcode = this.sampleList[0].barcode;
        obj.shirt_design_no = this.sampleList[0].design_no;
        obj.slv = this.sampleList[0].slv;
        obj.size = this.sampleList[0].size;
        obj.mrp = this.sampleList[0].mrp;
        obj.color = this.sampleList[0].color;
        obj.shade = this.sampleList[0].code;
        obj.unitid = this.sampleList[0].unitid;
        obj.mfg_date = this.sampleList[0].mfg_date;
        obj.act_mfg_date = this.sampleList[0].act_mfg_date;
        obj.design_id = this.sampleList[0].design_id;
        obj.F34 = this.sampleList[0].F34;
        obj.F36 = this.sampleList[0].F36;
        obj.F38 = this.sampleList[0].F38;
        obj.F40 = this.sampleList[0].F40;
        obj.F42 = this.sampleList[0].F42;
        obj.F44 = this.sampleList[0].F44;
        obj.H34 = this.sampleList[0].H34;
        obj.H36 = this.sampleList[0].H36;
        obj.H38 = this.sampleList[0].H38;
        obj.H40 = this.sampleList[0].H40;
        obj.H42 = this.sampleList[0].H42;
        obj.H44 = this.sampleList[0].H44;
        obj.DF34 = this.sampleList[0].DF34;
        obj.DF36 = this.sampleList[0].DF36;
        obj.DF38 = this.sampleList[0].DF38;
        obj.DF40 = this.sampleList[0].DF40;
        obj.DF42 = this.sampleList[0].DF42;
        obj.DF44 = this.sampleList[0].DF44;
        obj.DH34 = this.sampleList[0].DH34;
        obj.DH36 = this.sampleList[0].DH36;
        obj.DH38 = this.sampleList[0].DH38;
        obj.DH40 = this.sampleList[0].DH40;
        obj.DH42 = this.sampleList[0].DH42;
        obj.DH44 = this.sampleList[0].DH44;
        obj.mrp = this.sampleList[0].mrp;
        obj.hsrate = this.sampleList[0].hsrate;
        obj.fsrate = this.sampleList[0].fsrate;
        obj.barcode = this.sampleList[0].barcode;
        obj.running_no = this.sampleList[0].running_no;
        obj.dc_id = this.sampleList[0].dc_id;
        obj.ref_id = this.sampleList[0].ref_id;
        obj.ref_type = this.sampleList[0].ref_type;

        if (obj.slv == "F/S") {
          obj.rate = this.sampleList[0].fsrate;
        } else {
          obj.rate = this.sampleList[0].hsrate;
        }
        obj.pcs = 1;
        obj.mrp = this.sampleList[0].mrp;
        obj.amount = this.sampleList[0].mrp;
        let new_code = this.sampleList[0].barcode;
        for (var b = 0; b < this.groupList.length; b++) {
          let old_code = this.groupList[b].barcode;
          if (new_code == old_code) {
            let no = b + 1;
            swal("Barcode number " + new_code + " Already Exists at Sno " + no);
            this.barcode = "";
            return false;
          }
        }
        this.groupList.push(obj);
        this.barcode = "";
      });
    } else {
      this.sampService.barcodeData(params).then((res: any) => {
        this.sampleList = res.data;

        let obj: any = {};
        obj.barcode = this.sampleList[0].barcode;
        obj.shirt_design_no = this.sampleList[0].design_no;
        obj.slv = this.sampleList[0].slv;
        obj.size = this.sampleList[0].size;
        obj.mrp = this.sampleList[0].mrp;
        obj.color = this.sampleList[0].color;
        obj.shade = this.sampleList[0].code;
        obj.unitid = this.sampleList[0].unitid;
        obj.mfg_date = this.sampleList[0].mfg_date;
        obj.act_mfg_date = this.sampleList[0].act_mfg_date;
        obj.design_id = this.sampleList[0].design_id;
        obj.F34 = this.sampleList[0].F34;
        obj.F36 = this.sampleList[0].F36;
        obj.F38 = this.sampleList[0].F38;
        obj.F40 = this.sampleList[0].F40;
        obj.F42 = this.sampleList[0].F42;
        obj.F44 = this.sampleList[0].F44;
        obj.H34 = this.sampleList[0].H34;
        obj.H36 = this.sampleList[0].H36;
        obj.H38 = this.sampleList[0].H38;
        obj.H40 = this.sampleList[0].H40;
        obj.H42 = this.sampleList[0].H42;
        obj.H44 = this.sampleList[0].H44;
        obj.DF34 = this.sampleList[0].DF34;
        obj.DF36 = this.sampleList[0].DF36;
        obj.DF38 = this.sampleList[0].DF38;
        obj.DF40 = this.sampleList[0].DF40;
        obj.DF42 = this.sampleList[0].DF42;
        obj.DF44 = this.sampleList[0].DF44;
        obj.DH34 = this.sampleList[0].DH34;
        obj.DH36 = this.sampleList[0].DH36;
        obj.DH38 = this.sampleList[0].DH38;
        obj.DH40 = this.sampleList[0].DH40;
        obj.DH42 = this.sampleList[0].DH42;
        obj.DH44 = this.sampleList[0].DH44;
        obj.mrp = this.sampleList[0].mrp;
        obj.hsrate = this.sampleList[0].hsrate;
        obj.fsrate = this.sampleList[0].fsrate;
        obj.barcode = this.sampleList[0].barcode;
        obj.running_no = this.sampleList[0].running_no;
        obj.dc_id = this.sampleList[0].dc_id;
        obj.ref_id = this.sampleList[0].ref_id;
        obj.ref_type = this.sampleList[0].ref_type;

        if (obj.slv == "F/S") {
          obj.rate = this.sampleList[0].fsrate;
        } else {
          obj.rate = this.sampleList[0].hsrate;
        }
        obj.pcs = 1;
        obj.mrp = this.sampleList[0].mrp;
        obj.amount = this.sampleList[0].mrp;

        this.groupList.push(obj);
        this.barcode = "";
      });
    }
  }

  addfairScan() {
    let design = this.groupList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      design[i].samp_id = this.samp_id;
      if (design[i].barcode != "") {
        desList.push(design[i]);
      }
    }
    this.groupList = desList;
    this.savefairSample();
  }
  getcontents(ind) {
    this.groupList[ind].size = this.sampleList[0].size;
    this.groupList[ind].slv = this.sampleList[0].slv;
    this.groupList[ind].shirt_design_no = this.sampleList[0].shirt_design_no;
  }
  calamt(pcs, ind) {
    let temp = this.categoryList;
    this.groupList[ind].amount = this.groupList[ind].rate * pcs;
    this.groupdata.tot_pcs = 0;
    this.groupdata.tot_amt = 0;
    for (var i = 0; i < this.groupList.length; i++) {
      this.groupdata.tot_pcs += parseInt(this.groupList[i].pcs);
      this.groupdata.tot_amt += parseInt(this.groupList[i].amount);
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shirt_design_no = this.groupList[ind]["shirt_design_no"],
      color = this.groupList[ind]["color"],
      shade = this.groupList[ind]["shade"],
      size = this.groupList[ind]["size"],
      slv = this.groupList[ind]["slv"],
      //  width = this.data.designList[ind]['width'],
      pcs = this.groupList[ind]["pcs"],
      mrp = this.groupList[ind]["mrp"],
      rate = this.groupList[ind]["rate"],
      amount = this.groupList[ind]["amount"];

    let nxtRow = $("#row-" + ind).next("tr");

    //         for (let i = 0; i < this.groupList.length; i++) {
    //             if (ind + 1 == this.groupList.length) {

    //              //   let rowdetail = Object.assign({}, this.row);

    //                 this.groupData.push();

    //                 nxtInd = this.groupList.length - 1;

    //     }
    // }
    // if (fld == "sample_no"  && nxtRow.length == 0) {
    //     let len = this.groupList.length;
    //     let sample_no = this.groupList[len-1]['sample_no'];
    //   //  let qty = this.groupList[len-1].qty;
    //       nxtInd= nxtInd + 1;
    //     $('#' + this.page_id + 'sample_no' + '-' + nxtInd).focus();

    this.groupList.push({
      sample_no: "",
      shirt_design_no: "",
      color: "",
      shade: "",
      size: "",
      slv: "",
      pcs: "",
      rate: "",
      mrp: "",
      amount: "",
    });
    this.groupList[ind].samp_id = this.groupList[0].samp_id;
    $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();
  }

  // getStyleNoList(){
  //     this.sampService
  //     .getStyleNoList({})
  //     .then((res: any) => {

  //       this.styleNoList = res.data;

  //     });
  // }

  // generateDNo(style){
  //
  //                 let params={
  //                     style: style
  //                 }
  //     this.sampService
  //                     .getDesignNo(params)
  //                     .then((res: any) => {

  //                         this.sampledata.shirt_design_no = res.data[0].shirtdno;

  //                     });

  //             }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#" + "date").focus();
    }, 100);
  }

  onEnterKeyPressed() {
    $("#" + "sample_no-0").focus();
  }

  // onGoToNextFld($event, fld, ind) {
  //     let nxtInd = ind,
  //     fab_color = this.groupList[ind]['main_fab_color'];

  // let nxtRow = $('#row-' + ind).next('tr');

  // if (fab_color != '') {
  //     if (fld == "fab_color" && nxtRow.length == 0) {
  //         for (let i = 0; i < this.groupList.length; i++) {
  //             if (ind + 1 == this.groupList.length) {
  //                 this.groupList.push({
  //                     main_fab_color: '',
  //                     mat1_des_no: '',
  //                     mat1_color: '',
  //                     mat2_des_no:'',
  //                     mat2_color: '',
  //                     mat3_des_no: '',
  //                     mat3_color: '',
  //                     tape_no:'',
  //                     kaja_thread:'',
  //                     button_no:'',
  //                     button_thread:''
  //                 });

  //                 nxtInd = this.groupList.length - 1;
  //             }
  //         }
  //     }
  // }
  // setTimeout(() => {
  //     let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
  //     a.removeClass('mat-autocomplete-visible');
  //     $('#' + fld + '-' + nxtInd).focus();
  // }, 100);
  // }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }

  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }

  filterItems(name: string, comboType: string) {
    let list: any[];
    if (comboType == "Company") {
      list = this.companyList$;
    } else if (comboType == "Party") {
    }
    name = _.escapeRegExp(name);
    return list.filter((item) => new RegExp(name, "gi").test(item.name));
  }

  onEnterdesignno(list, ind) {
    let params = {
      design_no: list.design_no,
    };

    this.sampService.designlist(params).then((res: any) => {
      this.shadeList = res;

      // this.calcConsumption('$event',ind);
    });
  }

  // oncheckemptyrow() {
  //
  //     let list = this.groupList;
  //     let sampleList = [];
  //     for (let i = 0; i < list.length; i++) {
  //         if (list[i].main_fab_color != '') {
  //             sampleList.push(list[i]);
  //         }
  //     }
  //     this.groupList = sampleList;
  //     this.onSaveSample();
  // }

  addfairSample() {
    // this.sampledata.sampletype = this.typeList;
    let design = this.groupList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      design[i].samp_id = this.samp_id;
      if (design[i].sample_no != "") {
        desList.push(design[i]);
      }
    }
    this.groupList = desList;
    this.savefairSample();
  }
  resetform() {
    $("#f1").trigger("reset");
    this.sampledata.sample_type = "";
    this.groupList = [
      {
        barcode: "",
        shirt_design_no: "",
        color: "",
        shade: "",
        size: "",
        slv: "",
        pcs: "",
        rate: "",
        mrp: "",
        amount: "",
      },
    ];
    this.sampleList = [];
    this.colorList = [];
  }
  savefairSample() {
    if (
      this.groupList[0].barcode == "" ||
      this.groupList[0].amount == "" ||
      this.groupList[0].shade == "" ||
      this.groupList[0].pcs == ""
    ) {
      swal("make sure all the datas are given");
    } else {
      let params: any = Object.assign({}, this.sampledata);
      params["tabevent"] = undefined;
      params["fairList"] = JSON.stringify(this.groupList);
      //  params['workorder'] = this.dcdata.workorder || '';
      params["mode"] = this.mode;

      let that = this;
      that.isLoading = true;
      //  params['groupList'] = JSON.stringify(this.groupList);

      swal({
        title: "Are you sure to save this Sample?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(
        function () {
          that.isLoading = true;

          if (that.sampledata.sample_type == "OUTWARD") {
            that.sampService
              .removefairscan(params)
              .then(function (res: any) {
                that.isLoading = false;
                if (that.saveEvent) {
                  that.saveEvent.emit();
                }

                if (res.success) {
                  that.toasterService.pop({
                    bodyOutputType: 1,
                    type: "success",
                    title: "SUCCESS",
                    body: res.message,
                  });
                  // if (that.typeList=="INWARD"){

                  // }

                  that.store.dispatch(
                    new appConfigActions.SetLoadInvoice(true)
                  );
                  that.resetform();
                } else {
                  swal("ERROR", res.message, "error");
                }
              })
              .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal("ERROR", res.message, "error");
              });
          } else {
            that.sampService
              .addfairscan(params)
              .then(function (res: any) {
                that.isLoading = false;
                if (that.saveEvent) {
                  that.saveEvent.emit();
                }

                if (res.success) {
                  that.toasterService.pop({
                    bodyOutputType: 1,
                    type: "success",
                    title: "SUCCESS",
                    body: res.message,
                  });
                  // if (that.typeList=="INWARD"){

                  // }
                  that.sampService
                    .fairStickerprint(res)
                    .then(function (res: any) {});
                  that.store.dispatch(
                    new appConfigActions.SetLoadInvoice(true)
                  );
                  that.resetform();
                } else {
                  swal("ERROR", res.message, "error");
                }
              })
              .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal("ERROR", res.message, "error");
              });
          }
        },
        function (dismiss) {}
      );
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/fairStock.ts